import BaseAPI from './base.api';

export default class MlInsightsAPI extends BaseAPI {
  getMlInsights = async (range: string, startDate: string, endDate: string) => {
    const response = await this.API.get('ml-insights', {
      params: { range, startDate, endDate },
    });
    return response.data;
  };

  getMLImpact = async (insight: string) => {
    const response = await this.API.get('ml-insights/impact', {
      params: { insight },
    });
    return response.data;
  };

  getSupportingEvidence = async (
    dateTime: string,
    device: string,
    insight: string,
    isTransmissionInefficiency: boolean
  ) => {
    const response = await this.API.get('ml-insights/evidence-values', {
      params: {
        dateTime,
        device,
        insight,
        is_transmission_inefficiency: isTransmissionInefficiency,
      },
    });
    return response.data;
  };

  getSupportingEvidenceV2 = async (args: {
    selectedTag: string;
    device: string;
    fromTs: string;
    toTs?: string;
  }) => {
    const params = {
      customerId: this.customerId,
      selectedTag: args.selectedTag,
      device: args.device,
      fromTs: args.fromTs,
      ...(args.toTs ? { toTs: args.toTs } : {}),
    };

    const response = await this.API.get('ml-insights/evidence-values-v2', {
      params,
    });
    return response.data;
  };

  upsertInsight = async (data: {
    insightName: string;
    insightDate: string;
    deviceId: string;
    status: string;
  }) => {
    const response = await this.API.post('ml-insights/upsert', data);
    return response.data;
  };

  getUpsertedInsight = async () => {
    const response = await this.API.get('ml-insights/updated-insights');
    return response.data;
  };

  getAirFilterInsights = async (
    range: string,
    startDate: string,
    endDate: string
  ) => {
    const response = await this.API.get('ml-insights/air-filter-insights', {
      params: {
        range,
        startDate,
        endDate,
      },
    });
    return response.data;
  };

  getAirFilterEvidence = async (
    dateTime: string,
    device: string,
    insight: string
  ) => {
    const response = await this.API.get(
      'ml-insights/air-filter-evidence-values',
      {
        params: {
          dateTime,
          device,
          insight,
        },
      }
    );
    return response.data;
  };

  /** version 2 */
  getMlInsightsV2 = async (
    range: string,
    startDate: string,
    endDate: string,
    options?: {
      page?: number;
      limit?: number;
      isActive?: boolean;
    }
  ) => {
    const response = await this.API.get('ml-insights-v2', {
      params: {
        customerId: this.customerId,
        range,
        startDate,
        endDate,
        page: options?.page,
        limit: options?.limit,
        isActive: options?.isActive,
      },
    });
    return response.data;
  };

  updateMlInsightStatus = async (notificationId: string, isActive: boolean) => {
    const response = await this.API.patch(
      `ml-insights-v2/${notificationId}/status`,
      {
        isActive,
        customerId: this.customerId,
      }
    );
    return response.data;
  };
}
